import React, { useMemo, useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import CategoryApi from "../../api/categoryApi";
import {
  // SETCATEGORYLIST,
  SETSELECTEDCATEGORY,
} from "../../redux/features/categoryList";
import NoInternet from "../Modal/NoInternet";
import SideBarSkelton from "./SideBarSkelton";
import { capitalizeFirstLetter } from "../../utils/TitleWord";
import { getCategoryList } from "../../utils/helper";
import i18next from "i18next";
import { getItemNames } from "../../utils/GetItemsName";

import useStoreStatus from "../../hooks/useStoreStatus";
import { setStoreCloseModal } from "../../redux/features/store";
import { scrollToTop } from "../../utils/scrollToTop";
import { scrollToElementWithOffset } from "../../utils/scrollToElementWithOffset";
import { useNavigate } from "react-router-dom";
import useSearchItem from "../../hooks/useSearchItem";
import { sessionStorage_keys } from "../../constant/constant";
import { useMenuItemScroll } from "../../hooks/useMenuItemScroll";
export default function Sidebar() {
  const dispatch = useDispatch();
  const { returnIsStoreClose } = useStoreStatus();
  const { handleSearchClear } = useSearchItem();
  const {handleItemScroll}=useMenuItemScroll()
  const loading = false;
  const navigate = useNavigate();

  const containerRef = useRef<HTMLDivElement>(null);
  // const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lang, setLang] = useState(i18next.language);
  const {
    // filterData,
    categoryData: { selectedCategory },
    filterData: { search, filterCategory },
    // cartData: { itemCount, items },
    store: { allCategory },
    languageData: { translations },
  }: any = useSelector((state: any) => state);

  let sidebarClickTimeout: NodeJS.Timeout | null = null;

useEffect(()=>{
  sessionStorage.setItem(sessionStorage_keys.isSidebarClicking,"false")
  return ()=>{
    sessionStorage.setItem(sessionStorage_keys.isSidebarClicking,"false")
  
  }
},[])

  const handleChangeCategory = async (slug: string) => {
    // @@
    if (returnIsStoreClose) {
      handleOpenStoreCloseModal();
      return;
    }
    if (sidebarClickTimeout) {
      clearTimeout(sidebarClickTimeout);
    }

    await handleSearchClear();
    dispatch(SETSELECTEDCATEGORY(slug));
    navigate(`?slug=${slug}`);
    // sessionStorage.setItem(sessionStorage_keys.isSidebarClicking, "true");
    // await scrollToElementWithOffset(slug, 80);
    // sessionStorage.removeItem(sessionStorage_keys.isSidebarClicking);
    handleItemScroll(slug)
   
    sidebarClickTimeout = setTimeout(() => {
      sidebarClickTimeout = null;
    }, 1000);
  };
  const handleOpenStoreCloseModal = () => {
    dispatch(setStoreCloseModal(true));
  };

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);

  // @@ return search filter categoyr
  const returnCategoryData = useMemo(() => {
    // let categoryData = search ? filterCategory : allCategory;
    let categoryData = allCategory;
    return categoryData; // getCategoryList(categoryData);
  }, [search]);
  return (
    <>
      <div className="pageSideBar">
        <div className="sideBarLogo">
          <div className="menuList" ref={containerRef}>
            <ul>
              {loading ? (
                <SideBarSkelton />
              ) : (
                returnCategoryData?.map((value: any, index: any) => {
                  return (
                    <li
                      key={index}
                      className={
                        value?.slug == selectedCategory ? "active " : ""
                      }
                      onClick={() => handleChangeCategory(value?.slug)}
                    >
                      <button
                        type="button"
                        className=" navBtn hover:text-[#34558B] "
                      >
                        {/* {value?.name} */}
                        {getItemNames(value?.name, translations, lang)}
                      </button>
                    </li>
                  );
                })
              )}
            </ul>
            {/* <div className='sideBarFooter'>
                            <div className='footerButton'>

                                <Link to="/" className='btn'>

                                    <img src="../logo.png" alt="Logo" />
                                </Link>
                            </div>
                            <ul>
                                <li>
                                    <Link to="#" className='btn'>
                                        <img src="../googleplay.svg" alt="Button" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className='btn'>
                                        <img src="../googleplay.svg" alt="Button" />
                                    </Link>
                                </li>
                            </ul>
                        </div> */}
          </div>
        </div>
      </div>
      {/* {!isOnline && <NoInternet isOnline={isOnline} />} */}
    </>
  );
}
